export default __webpack_public_path__ + "static/media/parceiros2.8e56e7a1.jpg";